<template>
  <v-layout :loading="loading">
    <template v-if="!loading">
      <d-header
        :actions="[{
          label: $t('edit'),
          path: '/property-inspections/' + model.id + '/edit',
          primary: true,
          color: 'is-grey',
          icon: 'pencil'
        }]"
      >
        <h1 class="title">
          <d-previous-btn
            :path="'/properties/' + $route.params.property + '/property-inspections'"
          />
          {{ model.name }}
        </h1>
      </d-header>

      <d-container paddingless-mobile>
        <d-card class="mb-0">
          <d-card-row>
            <h2 class="title is-5">
              Details
            </h2>
            <ul>
              <li class="mb-2">
                {{ model.name }}
              </li>
            </ul>
          </d-card-row>
        </d-card>
      </d-container>
    </template>
  </v-layout>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.title,
      __property_inspection: this.title // for breadcrumb
    };
  },
  data () {
    return {
      model: {},
      loading: true
    };
  },
  computed: {
    title () {
      if (this.model.name) {
        return this.model.name;
      }
      return "";
    }
  },
  created () {
    this.$http.get(this.$laravel.route("api.property-inspections.show", {property_inspection: this.$route.params.propertyInspection}))
      .then(response => {
        this.loading = false;
        this.model = response.data.data;
      })
      .catch((e) => {
        console.error(e);
        this.$router.push("/property-inspections");
      });
  }
};
</script>
